export default __webpack_public_path__ + "static/media/player_5.0d498bf5.mp3";